import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "lucide lucide-heading-2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M4 12h8" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M4 18V6" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", { d: "M12 18V6" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", { d: "M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1" }, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }